import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const NoShowModal = ({ open, toggle, tripDetails, onSubmit }) => {
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setRemarks("");
    setError("");
    toggle();
  };

  const handleSubmit = () => {
    if (!remarks.trim()) {
      setError("Please enter remarks");
      return;
    }
    onSubmit({
      tripId: tripDetails?.id,
      remarks: remarks, // Sending remarks as per new backend API
    });
    handleClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="no-show-modal-title"
      className="customModal"
      onClose={handleClose}
    >
      <Box className="modalContent textLeft" sx={{ maxWidth: 500, p: 3 }}>
        <Box className="justifyBetween mb20">
          <Typography variant="head4" className="colorPrimary fw600">
            Mark as No-Show
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body2" className="colorGrey mb20">
          Trip ID: {tripDetails?.tripId}
        </Typography>

        <Typography variant="body2" className="fw600 mb10">
          Remarks *
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="e.g., Passenger did not arrive at pickup point"
          value={remarks}
          onChange={(e) => {
            setRemarks(e.target.value);
            if (error) setError("");
          }}
          error={!!error}
          helperText={error}
          size="small"
        />

        <Box className="justifyEnd mt30">
          <Button variant="outlined" onClick={handleClose} sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!remarks.trim()}
          >
            Mark No-Show
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoShowModal;
